<template>
  <main>
    <thing-single-header></thing-single-header>
    <thing-single></thing-single>
<!--    <pre>{{thing}}</pre>-->
  </main>
</template>

<script>
  import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import thingSingleHeader from '../../components/Pages/Things/Headers/thignSingle/thingSingleHeader'
  import thingSingle from '../../components/Pages/Things/ThingSingle/thingSingle'
  import {pageSettings} from "../../mixins/utils/pageSettings";

  export default {
    name: 'thingsThing',
    mixins: [tokenAndRoute, loaderMixin, pageSettings],
    components: {
      thingSingleHeader,
      thingSingle
    },
    /*data: () => ({
      thing: null
    }),*/
    computed: {
      ...mapState({
        thing: state => state.things.device,
        projects: state => state.projects.allProjects,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned
      }),
      ...mapGetters({
        isAdminRole: 'auth/adminRole',
      }),
    },
    methods: {
      ...mapActions({
        //getDevice: 'things/getDevice',
      }),
      ...mapMutations({
        setDevice: 'things/SET_DEVICE',
      }),
      getDevice() {
        let device;
        let getDeviceData = (arr) => {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].devices.length > 0) {
              for (let j = 0; j < arr[i].devices.length; j++) {
                if (arr[i].devices[j].id === Number(this.routeId)) {
                  device = arr[i].devices[j]
                  break;
                }
              }
            }
            if (arr[i].items.length > 0) {
              getDeviceData(arr[i].items)
            }
          }
        }

        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].items.length > 0) {
            getDeviceData(this.projects[i].items)
          }
        }

        let finish = () => {
          this.setDevice(device)
          this.setRouteName(this.thing.name);
          document.title = `OmniioTh | Вещь ${this.thing.name}`;
        }

        let searchThingForRole = () => {
          let allThingsInProjectArr = []
          let projectFunc = (data) => {
            data.forEach((item) => {
              if (item.devices.length > 0) {
                item.devices.forEach((device) => {
                  allThingsInProjectArr.push(device)
                })
              }
              if (item.items.length > 0) {
                projectFunc(item.items)
              }
            })
          }
          this.projects.forEach((project) => {
            if (project.devices) {
              project.devices.forEach((device) => {
                allThingsInProjectArr.push(device)
              })
            }
            if (project.items.length > 0) {
              projectFunc(project.items)
            }
          })
          allThingsInProjectArr = allThingsInProjectArr.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set))
          return allThingsInProjectArr
        }


        if (device) {
          finish()
        } else {
          if (this.isAdminRole) {
            device = this.allThingsFromGetOwned.find(device => device.id === Number(this.routeId));
            device.permission_level = 4;
          } else {
            device = searchThingForRole().find(device => device.id === Number(this.routeId));
          }
          finish()
        }
      },
    },
    watch: {
      projects() {
        this.getDevice();
      },
      async routeId() {
        this.showLoader();
        await this.getDevice(this.routeId);
        this.hideLoader();
      },
    },
    mounted() {
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const token = localStorage.getItem('token');
        const param = vm.$route.params.id;
        vm.showLoader();
        await vm.getDevice();
        vm.setFullSidebar(false);
        vm.setLinkName('things');
        vm.hideLoader()
      })
    }
  }
</script>
